import { FilterCategoryState, FilterEventDetail } from '../components/filters';

let filters: FilterCategoryState[] = [];

if (document.querySelector('main.usage')) {
    const gallery = document.querySelector<HTMLElement>('#usage-gallery');
    // const galleryParent = gallery?.parentElement;
    const nowShowing = document.querySelector<HTMLSpanElement>('#now-showing');
    const showMoreBtn = document.querySelector<HTMLButtonElement>('#show-more');
    const filterToggleBtn = document.querySelector<HTMLButtonElement>('#filter-toggle');

    filterToggleBtn?.addEventListener('click', () => {
        if (document.querySelector<HTMLElement>('#filters')?.classList.contains('d-lg-none')) {
            gallery?.classList.remove('row-cols-xl-3');
            gallery?.classList.add('row-cols-xl-4');
        } else {
            gallery?.classList.add('row-cols-xl-3');
            gallery?.classList.remove('row-cols-xl-4');
        }
    });

    const nextTwelve = () => {
        const filterKeyword = document.querySelector<HTMLInputElement>('#filter-keyword');
        const hiddenCards = Array.from(gallery?.querySelectorAll<HTMLElement>('.d-none') ?? []);
        for (let i = 0; i < 12; i++) {
            const use = hiddenCards?.shift();
            if (use) {
                const tags = use?.getAttribute('data-tags');
                let matches = true;
                const title = use.querySelector<HTMLElement>('.usage-card-title')?.innerText.toLowerCase();
                const keyword = filterKeyword?.value.toLowerCase();
                if (keyword && keyword !== '' && !title?.includes(keyword)) {
                    matches = false;
                }
                if (matches && tags) {
                    const tagJSON = JSON.parse(tags) as Record<string, string>;
                    filters?.forEach(filter => {
                        let hasTag = false;
                        const filterName = filter.name;
                        Object.keys(tagJSON).forEach(k => {
                            const tagName = k;
                            const tagValue = tagJSON[k];
                            if (tagName !== filterName) {
                                return;
                            }
                            hasTag = true;
                            if (!filter.options.includes(tagValue)) {
                                matches = false;
                            }
                        });
                        if (!hasTag) {
                            matches = false;
                        }
                    });
                }
                if (!matches) {
                    i--;
                    continue;
                }
                use.classList.remove('d-none');
            } else {
                showMoreBtn?.classList.add('d-none');
                break;
            }
        }
        if (nowShowing) {
            const shownCards = gallery?.querySelectorAll<HTMLElement>('.usage-card-parent:not(.d-none)');
            const shownCount = shownCards?.length ?? 0;
            nowShowing.innerText = `Showing ${shownCount} of ${shownCount + futureMatches(hiddenCards)}`;
        }
        if (futureMatches(hiddenCards) === 0) {
            showMoreBtn?.classList.add('d-none');
        }
    };

    nextTwelve();

    const hideAll = () => {
        const allCards = gallery?.querySelectorAll<HTMLElement>('.usage-card-parent');
        allCards?.forEach(card => {
            card.classList.add('d-none');
        });
        showMoreBtn?.classList.remove('d-none');
    };
    showMoreBtn?.addEventListener('click', nextTwelve);

    document.addEventListener('filterUpdate', ((e: CustomEvent<FilterEventDetail>) => {
        filters = e.detail.filters;
        hideAll();
        nextTwelve();
    }) as EventListener);
}

function futureMatches(hiddenCards: HTMLElement[]): number {
    const filterKeyword = document.querySelector<HTMLInputElement>('#filter-keyword');
    let matches = 0;
    hiddenCards.forEach(card => {
        const tags = card.getAttribute('data-tags');
        let cardMatches = true;
        const title = card.querySelector<HTMLElement>('.usage-card-title')?.innerText.toLowerCase();
        const keyword = filterKeyword?.value.toLowerCase();
        if (keyword && keyword !== '' && !title?.includes(keyword)) {
            cardMatches = false;
        }
        if (cardMatches && tags) {
            const tagJSON = JSON.parse(tags) as Record<string, string>;
            filters?.forEach(filter => {
                let hasTag = false;
                const filterName = filter.name;
                Object.keys(tagJSON).forEach(k => {
                    const tagName = k;
                    const tagValue = tagJSON[k];
                    if (tagName !== filterName) {
                        return;
                    }
                    hasTag = true;
                    if (!filter.options.includes(tagValue)) {
                        cardMatches = false;
                    }
                });
                if (!hasTag) {
                    cardMatches = false;
                }
            });
        }
        if (cardMatches) {
            matches++;
        }
    });
    return matches;
}

export function SetInitialFilters(initialFilters: FilterCategoryState[]) {
    filters = initialFilters;
}
